import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Stack, Container } from '@mantine/core';

import TicketSummary from '../../components/TicketSummary/TicketSummary';
import PrimaryButton from '../../components/GroupButton';

const AddVasTicket = () => {
  const { search } = useLocation();

  const searchParams = new URLSearchParams(search);
  const passIdData = searchParams.get('passId');
  const mobile = searchParams.get('mobile');
  const firstName = searchParams.get('name');

  return (
    <Box style={{ height: 'calc(100vh - 24px)', marginTop: '24px' }}>
      <Stack justify="space-between" style={{ height: '100%' }}>
        <Box>
          <Container
            className="home"
            style={{
              display: 'flex',
              alignItems: 'stretch',
              flexDirection: 'column',
            }}
          >
            <PrimaryButton />
          </Container>
        </Box>
        <Box style={{ flexGrow: '1' }}>
          <Container
            className="home"
            style={{
              display: 'flex',
              alignItems: 'stretch',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <TicketSummary passId={passIdData} mobileNumber={mobile} name={firstName} />
          </Container>
        </Box>
      </Stack>
    </Box>
  );
};

export default AddVasTicket;
